import React from "react";

var ClearIcon = function ClearIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 14 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 14 : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5H0V4.5V0.5V0H1V0.5V3.40625C2.21875 1.375 4.4375 0 7 0C10.8438 0 14 3.15625 14 7C14 10.875 10.8438 14 7 14C4.28125 14 1.9375 12.4688 0.78125 10.25L1.65625 9.78125C2.65625 11.7188 4.65625 13 7 13C10.3125 13 13 10.3125 13 7C13 3.6875 10.3125 1 7 1C4.78125 1 2.8125 2.21875 1.78125 4H4.5H5V5H4.5H0.5Z",
    fill: "#212223"
  }));
};

export default ClearIcon;